import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {Mitarbeiter} from 'shared/dtos/mitarbeiter';
import {AdditionalInfo} from 'shared/dtos/wizard/additional-info';

import {
  ValidationWorkerInputData,
  ValidationWorkerOutputProgress,
  ValidationWorkerOutputResult,
  ValidationWorkerOutputType
} from './validation-worker-data';

@Injectable({
  providedIn: 'root'
})
export class DataValidationService {
  private readonly worker: Worker;
  private status$: Subject<ValidationWorkerOutputProgress>;

  constructor() {
    // eslint-disable-next-line no-negated-condition
    if (typeof Worker !== 'undefined') {
      this.worker = new Worker(new URL('./validation.worker', import.meta.url));
    } else {
      // Web workers are not supported in this environment.
      // You should add a fallback so that your program still executes correctly.
    }
  }

  performValidation(
    mitarbeiters: Mitarbeiter[],
    additionalInfo: AdditionalInfo,
    isForM2: boolean
  ) {
    return this.performValidationWithWorker(
      mitarbeiters,
      additionalInfo,
      isForM2
    );
  }

  getStatus() {
    if (this.status$) {
      this.status$.complete();
    }
    this.status$ = new Subject<ValidationWorkerOutputProgress>();
    return this.status$.asObservable();
  }

  private performValidationWithWorker(
    mitarbeiters: Mitarbeiter[],
    additionalInfo: AdditionalInfo,
    isForM2: boolean
  ) {
    const result = new Promise<ValidationWorkerOutputResult>(
      (resolve, reject) => {
        this.worker.onmessage = ({data}) => {
          if (data.type === ValidationWorkerOutputType.RESULT) {
            resolve(data);
          } else if (data.type === ValidationWorkerOutputType.PROGRESS) {
            const progress = data as ValidationWorkerOutputProgress;
            this.status$?.next(progress);
          }
        };
        this.worker.onerror = error => {
          reject(error);
        };
      }
    );

    this.worker.postMessage({
      mitarbeiters,
      additionalInfo,
      isForM2
    } as ValidationWorkerInputData);
    const startTime = Date.now();
    return result;
  }
}
